Namespace 'Customer.Users'

class Customer.Users.ProfileConversationsView extends Backbone.View
  template: JST['backbone/templates/customer/users/conversations']
  overlayTemplate: JST['backbone/templates/customer/users/summary_click_overlay']
  className: 'tab-pane processing'
  id: 'user-conversations'

  initialize: (@options = {}) ->
    @hasConversations = false

  search: ->
    return if @hasConversations
    $.ajax
      type: 'POST'
      url: '/customer/dashboard/user_search'
      data:
        ids: @options.ids
      success: @render
      error: @error

  render: (response) =>
    @$el.removeClass('processing')
    @hasConversations = true
    if response.summaries?.length > 0
      @$el.html @template()
      @_processTicketSummary(summary) for summary in response.summaries
      @$el.find('.microscroll').nanoScroller()
    else
      @error(response)
    @

  _processTicketSummary: (summaryJSON) ->
    summary = new Customer.TicketSummary(summaryJSON, {})
    $overlay = $(@overlayTemplate(id: summary.get('id')))
    $overlay.append new Customer.Dashboard.TicketSummaryView(ticketSummary: summary).render().el
    @$el.find('.cs-tweets-list').append($overlay)
    @$el.find('.opening-ticket-button').hide()

  _errorMessage: (response) ->
    if response?.status == 401
      I18n.t('unauthorized.default')
    else if response?.summaries?.length == 0
      I18n.t('user_profiles.no_tickets_found')
    else
      I18n.t('user_profiles.tickets_cant_be_loaded')

  error: (response) =>
    errorMsg = $('<div></div>').text(@_errorMessage(response)).addClass('profile-error')
    @$el.removeClass('processing').html(errorMsg)
